import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const BreadcrumbsContainer = styled.div`
    grid-gap: ${BaseStyle.GAP_SIZES.medium}px ${BaseStyle.GAP_SIZES.small}px;
    display: flex;
    flex-flow: row wrap;

    @media print {
        display: none;
    }
`;

export const Breadcrumb = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    // TODO look into this color more
    background: rgba(0, 66, 187, 0.08);
    border: solid 1px ${({ theme }) => theme.Utility.cta};
    border-radius: 30px;
    color: ${({ theme }) => theme.Utility.cta};
    display: flex;
    padding: 6px 24px;
`;

export const BreadcrumbValue = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']};
    color: ${({ theme }) => theme.Utility.cta};
`;

export const DeleteBreadcrumb = styled(BreadcrumbValue)`
    ${BaseStyle.Mixins.fontStyles.ui['16b']};
    cursor: pointer;
    height: 16px;

    svg {
        fill: ${({ theme }) => theme.Utility.cta};
    }
`;

export const ClearFilter = styled(BreadcrumbValue)`
    ${BaseStyle.Mixins.fontStyles.ui['14b']};
    align-items: center;
    color: ${({ theme }) => theme.Utility.cta};
    cursor: pointer;
    display: flex;
    padding-top: 8px;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-left: 16px;
        padding-top: initial;
        width: initial;
    }
`;
